<template>
  <div>
    <template v-if="isAvailableToday">
      <div class="entryTicket" v-if="tour && isAvailable && !isSoldOut">
        <div
          class="flexContainer"
          v-if="
            tour.single_ticketing == 0 &&
            tour.book_complete_tour == 1 &&
            Object.keys(priceList).length === 1
          "
        >
          <div class="content">
            <div class="name">{{ tour.name }}</div>
            <div class="ticketHeader">
              <span class="duration" v-if="tour.duration">
                <Icon icon="clock"></Icon> {{ tour.duration }} {{ $t('MINUTES_SHORT') }}
              </span>
              <span
                class="minMaxParticipants"
                v-if="tour.min_participants || tour.max_participants"
              >
                <icon icon="users"></icon> {{ tour.min_participants }} –
                {{ tour.max_participants * maxToursForTime }}
              </span>
              <span class="languages"> <icon icon="comment"></icon> {{ tour.langName }} </span>
            </div>
            <div class="hint" v-if="tour.hint">{{ tour.hint }}</div>
            <div class="descriptionShopShort" v-if="tour.description_shop_short">
              {{ tour.description_shop_short }}
            </div>
            <div class="tourTypeName" v-if="tour.tourTypeName">{{ tour.tourTypeName }}</div>
          </div>

          <div class="values">
            <div v-if="entryTicket" class="price">{{ formatCurrency(entryTicket.price) }}</div>
            <div v-if="parseInt(tour.booking_without_tickets, 10) === 0" class="ticketCount">
              {{ ticketCount }} {{ $t('GUIDED_TOUR_PARTICIPANTS') }}
            </div>
            <div class="tourInput" v-if="!isBookableExternaly">
              <NumberInputWithButtons
                v-if="formTours[Object.keys(priceList)[0]]"
                :model-value="formTours[Object.keys(priceList)[0]].count"
                @input="setFormTourCount({ id: Object.keys(priceList)[0], count: $event })"
                :max="maxToursForTime"
              >
              </NumberInputWithButtons>
            </div>
          </div>
        </div>

        <!--Case 2 -->
        <div
          v-if="
            tour.single_ticketing == 0 &&
            tour.book_complete_tour == 1 &&
            Object.keys(priceList).length > 1
          "
        >
          <div class="content fullLength">
            <div class="name">{{ tour.name }}</div>
            <div class="ticketHeader">
              <span class="duration" v-if="tour.duration">
                <Icon icon="clock"></Icon> {{ tour.duration }} {{ $t('MINUTES_SHORT') }}
              </span>
              <span
                class="minMaxParticipants"
                v-if="tour.min_participants || tour.max_participants"
              >
                <icon icon="users"></icon> {{ tour.min_participants }} – {{ tour.max_participants }}
              </span>
              <span class="languages"> <icon icon="comment"></icon> {{ tour.langName }} </span>
            </div>
            <div class="hint" v-if="tour.hint">{{ tour.hint }}</div>
            <div class="descriptionShopShort" v-if="tour.description_shop_short">
              {{ tour.description_shop_short }}
            </div>
            <div class="tourTypeName" v-if="tour.tourTypeName">{{ tour.tourTypeName }}</div>
            <div class="tourPriceItem" v-for="k in tour.priceListOrder" :key="priceList[k].id">
              <div class="tourDescription">
                <div class="tourPriceItemName">{{ priceList[k].name }}</div>
                <div class="tourPriceItemDescription">{{ priceList[k].description_short }}</div>
                <div class="tourPriceItemPrice">{{ formatCurrency(priceList[k].price) }}</div>
              </div>
              <div class="tourInput" v-if="!isBookableExternaly">
                <NumberInputWithButtons
                  :model-value="formTours[k].count"
                  @input="setFormTourCount({ id: k, count: $event })"
                  :max="maxToursForTime"
                >
                </NumberInputWithButtons>
              </div>

              <!--div class="selector">
              <CheckInput type="radio" :fname="k" :model-value="(selectedPrice === k)"
              label="" v-on:input="selectTourPrice($event)" :key="priceList[k].id"/>
            </div-->
            </div>
          </div>
        </div>

        <!--Case 3 and 4 -->
        <div
          v-if="
            (tour.single_ticketing == 1 && tour.book_complete_tour == 0) ||
            (tour.single_ticketing == 1 && tour.book_complete_tour == 1)
          "
        >
          <div class="content fullLength">
            <div class="name">{{ tour.name }}</div>
            <div class="ticketHeader">
              <span class="duration" v-if="tour.duration">
                <Icon icon="clock"></Icon> {{ tour.duration }} {{ $t('MINUTES_SHORT') }}
              </span>
              <span
                class="minMaxParticipants"
                v-if="tour.min_participants || tour.max_participants"
              >
                <icon icon="users"></icon> {{ tour.min_participants }} – {{ tour.max_participants }}
              </span>
              <span class="languages"> <icon icon="comment"></icon> {{ tour.langName }} </span>
            </div>
            <div class="hint" v-if="tour.hint">{{ tour.hint }}</div>
            <div class="descriptionShopShort" v-if="tour.description_shop_short">
              {{ tour.description_shop_short }}
            </div>
            <div class="tourTypeName" v-if="tour.tourTypeName">{{ tour.tourTypeName }}</div>
            <template v-if="typeof priceList !== 'undefined'">
              <div class="tourPriceItem" v-for="k in tour.priceListOrder" :key="k">
                <template v-if="typeof priceList[k] !== 'undefined'">
                  <div class="content">
                    <div class="tourPriceItemName">{{ priceList[k].name }}</div>
                    <div class="tourPriceItemDescription">{{ priceList[k].description_short }}</div>
                  </div>
                  <div class="values" v-if="!isBookableExternaly">
                    <div class="price">{{ formatCurrency(priceList[k].price) }}</div>
                    <NumberInputWithButtons
                      v-if="formTours[priceList[k].id]"
                      :model-value="formTours[priceList[k].id].count"
                      @input="setFormTourCount({ id: priceList[k].id, count: $event })"
                    >
                    </NumberInputWithButtons>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import formater from '../../lib/formater';
import NumberInputWithButtons from '../Form/NumberInputWithButtons.vue';
import Icon from '../Icon.vue';

export default {
  name: 'GuidedTourFormTour',
  components: { NumberInputWithButtons, Icon },
  data() {
    return {
      selectedPrice: null,
      selectedPriceCount: 0,
    };
  },
  computed: {
    ...mapState({
      tour: (state) => state.guidedTours.data.single,
      ticketCount: (state) => state.guidedTours.form.ticketCount,
      tourCount: (state) => state.guidedTours.form.tourCount,
      formTours: (state) => state.guidedTours.form.tours,
    }),
    isBookableExternaly() {
      if (parseInt(this.tour.isBookable, 10) === -1) {
        return true;
      }
      return false;
    },
    maxToursForTime() {
      let v = 0;
      if (typeof this.$store.state.guidedTours.form.time !== 'undefined') {
        if (typeof this.$store.state.guidedTours.data.single.schedule !== 'undefined') {
          if (
            typeof this.$store.state.guidedTours.data.single.schedule[
              this.$store.state.guidedTours.form.time
            ] !== 'undefined'
          ) {
            v = parseInt(
              this.$store.state.guidedTours.data.single.schedule[
                this.$store.state.guidedTours.form.time
              ].tours,
              10
            );
          }
        }
      }
      return v;
    },
    priceList() {
      if (typeof this.$store.state.guidedTours.form.time !== 'undefined') {
        if (typeof this.$store.state.guidedTours.data.single.schedule !== 'undefined') {
          if (
            typeof this.$store.state.guidedTours.data.single.schedule[
              this.$store.state.guidedTours.form.time
            ] !== 'undefined'
          ) {
            if (
              typeof this.$store.state.guidedTours.data.single.schedule[
                this.$store.state.guidedTours.form.time
              ].priceList !== 'undefined'
            ) {
              return this.$store.state.guidedTours.data.single.schedule[
                this.$store.state.guidedTours.form.time
              ].priceList;
            }
          }
        }
      }
      return this.$store.state.guidedTours.data.single.priceList;
    },
    ...mapGetters({
      isAvailable: 'guidedTours/isAvailable',
      isAvailableToday: 'guidedTours/isAvailableToday',
      isSoldOut: 'guidedTours/isSoldOut',
    }),
    entryTicket() {
      const key = Object.keys(this.priceList);
      return this.priceList[key[0]];
    },
  },
  methods: {
    ...mapActions({
      setFormTourCount: 'guidedTours/setFormTourCount',
    }),
    getTourCount(id) {
      return this.formTours[id].count;
    },
    formatCurrency(val) {
      return formater.currency(val);
    },
    setSelectedPriceCount(params) {
      Object.keys(this.formTours).forEach((key) => {
        if (this.formTours[key].id !== params.id) {
          this.setFormTourCount({ id: key, count: 0 });
        }
      });
      this.setFormTourCount(params);
    },
    isTicketCountMoreThanAvailableTickets() {
      if (typeof this.formDate === 'undefined' || typeof this.formTime === 'undefined') {
        return true;
      }
      if (
        this.ticketCount >
        parseInt(this.calendarDatesAndTimes[this.formDate][this.formTime].tickets, 10)
      ) {
        return true;
      }
      if (parseInt(this.tour.booking_without_tickets, 10) === 1) {
        if (
          this.tourCount >
          parseInt(this.calendarDatesAndTimes[this.formDate][this.formTime].tickets, 10)
        ) {
          return true;
        }
      }
      return false;
    },
  },
  mounted() {
    if (
      parseInt(this.tour.single_ticketing, 10) === 0 &&
      parseInt(this.tour.book_complete_tour, 10) === 1 &&
      Object.keys(this.tour.priceList).length === 1
    ) {
      [this.selectedPrice] = Object.keys(this.tour.priceList);
      this.setSelectedPriceCount({ id: Object.keys(this.tour.priceList)[0], count: 1 });
      this.setFormTourCount({ id: Object.keys(this.tour.priceList)[0], count: 1 });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';

.name,
.price {
  font-weight: 600;
}

.tourTypeName {
  margin-top: $sp;
  font-weight: 600;
  margin-bottom: calc($sp / 2);
}

.entryTicket {
  background-color: $secondary-block-color-1;
}
.entryTicket {
  padding-top: $sp;
  padding-bottom: calc($sp / 2);
  @extend .row;
  margin-left: 0;
  margin-right: 0;
  .content {
    @extend .col-sm-7;
    @extend .col-xs-12;
    @media screen and (max-width: $screen-sm) {
      float: none;
    }
  }
  .content.fullLength {
    @extend .col-sm-12;
    @extend .col-xs-12;
  }
  .values {
    @extend .col-sm-5;
    @extend .col-xs-10;
    @extend .col-xs-offset-1;
    @extend .col-sm-offset-0;
    @media screen and (max-width: $screen-sm) {
      margin-top: 2 * $sp;
      margin-left: auto;
      margin-right: auto;
      float: none;
    }
    .price,
    .description {
      text-align: center;
    }
  }
}

.entryTicket {
  margin-top: 2 * $sp;
  margin-bottom: 2 * $sp;
  font-size: 0;
  .content,
  .values {
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
  }
  .ticketCount {
    text-align: center;
    margin-top: $sp;
    margin-bottom: 1 * $sp;
    font-weight: 600;
  }
  .price {
    margin-top: $sp;
  }
}

.ticketHeader {
  margin-top: calc($sp / 2);
  margin-bottom: $sp;
  .minMaxParticipants,
  .languages {
    margin-left: calc($sp / 2);
  }
}

.tourPriceItem {
  margin-bottom: $sp;
  display: flex;
  align-content: stretch;
  .tourPriceItemName {
    font-weight: 600;
  }
  .selector {
    padding-right: $sp;
  }
  .tourDescription {
    flex: 1 1 auto;
  }
}
.flexContainer {
  display: flex;
  align-content: stretch;
  .values {
    align-self: center;
  }
}
.tourPriceToggle {
  margin-top: 2 * $sp;
  text-align: center;
}
.selectedPriceCountInput {
  max-width: 50%;
  margin-top: $sp;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: $screen-md) {
  .flexContainer {
    flex-direction: column;
    .price {
      margin-bottom: $sp;
    }
  }
}

.content.fullLength {
  width: calc(100% - 30px) !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.entryTicket .values {
  padding-right: 0;
}
.tourInput {
  margin-right: $sp;
}
</style>
